// AUTO-GENERATED by scripts/build-registry.js: study entry for navigation/eastbound-flight-planning.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/navigation/eastbound-flight-planning/eastbound-flight-planning.js';

mount([g0]);
